
'use client';

import React from 'react';
import clsx from 'clsx';

export const NoiseOverlay: React.FC = () => {
  return (
    <div 
      className={clsx(
        "pointer-events-none fixed inset-0 z-50 mix-blend-overlay opacity-[0.015]"
      )}
    >
      <svg className="h-full w-full">
        <filter id="luxury-grain">
          <feTurbulence 
            type="fractalNoise" 
            baseFrequency="0.80" 
            numOctaves="4" 
            stitchTiles="stitch" 
          />
          <feColorMatrix type="matrix" values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.7 0" />
        </filter>
        <rect width="100%" height="100%" filter="url(#luxury-grain)" />
      </svg>
    </div>
  );
};